import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  padding-bottom: 3rem;
  position: ${(props) => (props.isBoxScore ? "absolute" : "unset")};
  top: 0;
  left: 0;
  .card-page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 15%;
    width: 100%;
    .option-content {
      display: flex;
      flex-direction: column;
      width: 30%;
    }
  }
  .card-container {
    width: 100%;
    height: 85%;
    border-radius: 24px;
    color: #fff;
    .top-container {
      background-color: black;
      background: linear-gradient(
        180deg,
        rgba(255, 74, 54, 1) 0%,
        rgba(0, 0, 0, 1) 100%
      );
      width: 100%;
      height: 55%;
      border-radius: 24px 24px 0 0;
      .header {
        display: flex;
        align-items: center;
        width: 100%;
        height: 70px;
        padding-top: 2rem;
        .logo-container {
          display: flex;
          width: 50%;
          padding-left: 1rem;
          img {
            width: auto;
            height: 50px;
            padding-right: 0.5rem;
          }
          h1 {
            font-size: 20px;
          }
        }
        .team-logo-container {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 0;
          img {
            display: block;
            width: 70px;
            height: 70px;
          }
        }
      }
      .placeholder-img {
        width: auto;
        height: 70%;
        max-height: 400px;
        margin: 0 auto;
        display: flex;
        align-items: center;
      }
    }
    .middle-container {
      background-color: #161616;
      width: 100%;
      height: 15%;
      .content-container {
        width: 70%;
        display: flex;
        justify-content: flex-start;
        margin: 0 auto;
        h1 {
          font-size: 40px;
        }
        hr {
          margin: 5% 1rem;
        }
        .sub-title {
          display: flex;
          justify-content: flex-start;
          font-weight: 700;
        }
      }
    }
    .bottom-container {
      background-color: #ff710a;
      width: 100%;
      height: 30%;
      border-radius: 0 0 24px 24px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .stat-container {
        display: flex;
        flex-direction: column;

        .stat {
          text-align: center;
          h3 {
            font-size: 40px;
            margin: 0;
          }
          p {
            font-weight: 700;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .card-page-header {
      width: 50%;
    }
    .card-container {
      width: 40%;
      .top-container .header .team-logo-container {
        justify-content: flex-end;
        padding-right: 2rem;
      }
    }
  }
`;

export const PopupContainer = styled.div`
  width: 100vw;
  min-height: 100vh;
  height: 100%;
  //display: flex;
  background-color: black;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  padding-bottom: 3rem;
  z-index: 100;
  top: -10vh;
  left: 0;
  .card-container {
    width: 100%;
    height: fit-content;
    border-radius: 24px;
    color: #fff;
    .top-container {
      background-color: black;
      background: linear-gradient(
        180deg,
        rgba(255, 74, 54, 1) 0%,
        rgba(0, 0, 0, 1) 100%
      );
      width: 100%;
      height: 55%;
      border-radius: 24px 24px 0 0;
      .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        height: 70px;
        padding: 2rem 0 0 0;
        box-shadow: unset;
        .logo-container {
          display: flex;
          width: calc(50% - 1rem);
          padding-left: 1rem;
          img {
            width: auto;
            height: 50px;
            padding-right: 0.5rem;
          }
          h1 {
            font-size: 20px;
          }
        }
        .team-logo-container {
          width: calc(50% - 2rem);
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-right: 0;
          img {
            display: block;
            width: 70px;
            height: 70px;
          }
        }
      }
      .placeholder-img {
        width: auto;
        height: 70%;
        max-height: 400px;
        margin: 0 auto;
        display: flex;
        align-items: center;
      }
    }
    .middle-container {
      background-color: #161616;
      width: 100%;
      height: 15%;
      .content-container {
        width: 70%;
        display: flex;
        justify-content: flex-start;
        margin: 0 auto;
        h1 {
          font-size: 40px;
        }
        hr {
          margin: 5% 1rem;
        }
        .sub-title {
          display: flex;
          justify-content: flex-start;
          font-weight: 700;
        }
      }
    }
    .bottom-container {
      background-color: #ff710a;
      width: 100%;
      height: 30%;
      border-radius: 0 0 24px 24px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .stat-container {
        display: flex;
        flex-direction: column;

        .stat {
          text-align: center;
          h3 {
            font-size: 40px;
            margin: 0;
          }
          p {
            font-weight: 700;
          }
        }
      }
    }
  }
  @media only screen and (min-width: 867px) {
    .card-container {
      width: 40%;
      .top-container .header .team-logo-container {
        justify-content: flex-end;
        padding-right: 2rem;
      }
    }
  }
`;
